import { DrawerContentComponentProps } from "@react-navigation/drawer";
import React from "react";
// TODO: - Stop using when the project is migrated.
import { logout as oldLogout } from "../../../../../old/redux/auth/authActions";
// TODO: - Stop using when the project is migrated.
import { useDispatch } from "react-redux";
import { useQueryClient } from "@tanstack/react-query";
import { Drawer, ParentRoute } from "./drawer";
import {
  logout,
  useAuth,
} from "../../../../../public/auth/infrastructure/store/auth-context";

type DrawerWrapperProps = DrawerContentComponentProps & {
  routes: Array<ParentRoute>;
};

export const DrawerWrapper = ({
  navigation,
  state,
  routes,
}: DrawerWrapperProps): React.ReactElement => {
  const { user, setData } = useAuth();
  const queryClient = useQueryClient();
  const dispatch = useDispatch();

  return (
    <Drawer
      routes={routes}
      isPageActive={(key) => state.index === key}
      goTo={(path, options) => navigation.navigate(path, options)}
      logout={() => {
        logout(setData, queryClient);
        // TODO: - Stop using when the project is migrated.
        dispatch(oldLogout());
      }}
      username={user?.name ?? ""}
      avatar={user?.avatar ?? ""}
    />
  );
};
